import { render, staticRenderFns } from "./BaseWaitingComponent.vue?vue&type=template&id=c8eda740&scoped=true"
import script from "./BaseWaitingComponent.vue?vue&type=script&lang=js"
export * from "./BaseWaitingComponent.vue?vue&type=script&lang=js"
import style0 from "./BaseWaitingComponent.vue?vue&type=style&index=0&id=c8eda740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8eda740",
  null
  
)

export default component.exports